

function setCountry() {

    let countrySelector = document.getElementById('select-country'),
        disabledCountryInput = document.getElementById('form-country')

    countrySelector.addEventListener('change', function() {
        console.log(this.options[this.selectedIndex].text)

        disabledCountryInput.value = this.options[this.selectedIndex].text

    })

}

setCountry()



// WEBPACK FOOTER //
// ./src/js/modules/setCountry.js